// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const DefensiveIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="m12 3.48 7.5 3.04v4.5a10 10 0 0 1-2.13 5.94A10.7 10.7 0 0 1 12 20.58a10.7 10.7 0 0 1-5.37-3.62 10 10 0 0 1-2.13-5.94v-4.5zm0-1.44q-.3 0-.59.11L3.91 5.2q-.41.16-.66.52-.25.37-.25.8v4.5a11.2 11.2 0 0 0 2.42 6.8c1.54 1.97 3.7 3.41 6.16 4.12q.42.12.84 0a12 12 0 0 0 6.17-4.12 11.2 11.2 0 0 0 2.41-6.8v-4.5q0-.43-.25-.8-.25-.36-.66-.52l-7.5-3.09A2 2 0 0 0 12 2z"
    />
  </svg>,
  "Defensive",
);
export default DefensiveIcon;
